module.exports = __webpack_public_path__ + "img/icon-03.df6ad99f.png";